import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { WebConstants } from 'src/app/util/web.constants';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { GeofenceService } from 'src/app/services/geofence.service';
import { HttpClient } from "@angular/common/http";

@Component({
  selector: 'app-geofence-detail-file-uploader',
  templateUrl: './geofence-detail-file-uploader.component.html',
  styleUrls: ['./geofence-detail-file-uploader.component.scss']
})
export class GeofenceDetailFileUploaderComponent implements OnInit {

  public fileData: File = null;
  public fileName: string = "No file Chosen";
  public fileSize: any = "";
  public allowedFileTypes: any = ["text/csv"];

  public progress: number = -1;
  public errorCount: any = 0;
  public passCount: any = 0;

  public userArray = [];

  constructor( 
    public dialogRef: MatDialogRef<GeofenceDetailFileUploaderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public toastrService: ToastrService,
    public geofenceService: GeofenceService,
    private http: HttpClient) {
  }

  ngOnInit() {
    console.log("GEOFENCE DETAIL IMPORT");
  }

  readCsv(){
    this.http.get('assets/csv.csv', {responseType: 'text'})
    .subscribe(
        data => {
            let csvToRowArray = data.split("\n");
            for (let index = 1; index < csvToRowArray.length - 1; index++) {
              let row = csvToRowArray[index].split(",");
              console.log(row);
              // this.userArray.push(new User( parseInt( row[0], 10), row[1], row[2].trim()));
            }
            console.log(this.userArray);
        },
        error => {
            console.log(error);
        }
    )
  }

  fileProgress(fileInput: any) {
    let fileData = <File>fileInput.target.files[0];
    if (this.allowedFileTypes.includes(fileData.type)) {
      this.fileData = fileData;
      this.fileName = fileData.name;
      this.fileSize = fileData.size;
      this.toastrService.info("File : " + this.fileName + " ; Size: " + this.fileSize, "File Selected");
    } else {
      this.fileData = null;
      this.fileName = "No file chosen";
      this.fileSize = "";
      this.toastrService.warning("Please select correct file", "Wrong File Type Error");
    }
  }

  public readFile(){

    if(this.fileData) {
        let reader: FileReader = new FileReader();
        reader.readAsText(this.fileData);
        
        reader.onload = (e) => {
          console.log(e);
          let payloadArr = [];
          let csv: string = reader.result as string;
          let rowArr = csv.split('\r\n');

          if(rowArr){
            for(let i=0;i<rowArr.length;i++){
              if(rowArr[i] && rowArr[i] != ""){
                let colArr = rowArr[i].split(',');
                console.log(colArr);
                if(i === 0 && !(colArr && colArr.length >= 1 && colArr[0] === 'Geofence ID')){
                  this.toastrService.error("Please follow Sample CSV ","Invalid Excel Header")
                  break;
                }
                if(colArr && colArr.length >= 1 && colArr[0] !== 'Geofence ID') {
                  let geofenceId = colArr[0];
                  let latitude = colArr[1];
                  let longitude = colArr[2];
                  let orgId = colArr[3];
                  let sequence = colArr[4];
                  let status = colArr[5];

                  if(geofenceId.trim() != '' && latitude.trim() != '' && longitude.trim() != '' && orgId.trim() != ''){
                      payloadArr.push({"geofenceId": geofenceId, "lat": latitude, "lng": longitude,
                                       "organizationId": orgId, "sequence": sequence, "status": status});
                      this.passCount += 1;
                  }
                  else{
                    this.errorCount += 1;
                  }
                }
              }
            }
          }

          if(payloadArr && payloadArr.length > 0){
            this.bulkUpload(payloadArr);
          }
        }        
      }
  }

  bulkUpload(payloadArr){
    this.geofenceService.addBulkGeofenceDetails(payloadArr)
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.toastrService.success(response.value, "Geofence Details Added Successfully!");
          if(this.errorCount > 0){
            this.toastrService.info(this.passCount + ' Geofence Details Added, </br>' + this.errorCount + ' Failed','Result',{ enableHtml:true });
          }
          else{
            this.toastrService.info(this.passCount + ' Geofence Details Added','Result',{ enableHtml:true });
          }
          this.closeDialog();
        } 
        else {
          this.toastrService.error(response.value, "Failed To Add Geofence Details!")
          this.closeDialog();
        }
      });
  }

  chooseFile() {
    let myInput = document.getElementById("myInput");
    myInput.click();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
